import { useState, useEffect } from 'react';
import api from '../../servicios/api';
import authService from '../../servicios/authService';
import equipoService from '../../servicios/equipoService';
import { getCargoColor } from '../compartidos/utils';

const GERENTE_COLOR = { general: '#111827', proyecto: '#4b5563' };

const CARGOS = ['Gerente de Proyecto', 'Administrador', 'Jefe de terreno', 'Supervisor', 'Calidad', 'Administrador de obra', 'Oficina tecnica', 'Jefe de Oficina Tecnica', 'Jefe de Bodega', 'Oficina Central'];

// ── Formulario para agregar integrante a un proyecto ──
const FormNuevoIntegrante = ({ proyectos, onCreado, onCancelar }) => {
  const [form, setForm] = useState({ proyectoId: '', nombre: '', email: '', cargo: '' });
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.proyectoId) { setError('Selecciona un proyecto'); return; }
    if (!form.nombre || !form.email || !form.cargo) { setError('Todos los campos son obligatorios'); return; }
    setGuardando(true);
    try {
      await equipoService.agregarMiembroEnProyecto(
        { nombre: form.nombre, email: form.email, cargo: form.cargo },
        form.proyectoId
      );
      onCreado();
    } catch (err) {
      setError(err.mensaje || err.error || 'Error al agregar integrante');
    } finally {
      setGuardando(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '20px', marginTop: '16px' }}>
      <h4 style={{ margin: '0 0 16px', fontSize: '14px', fontWeight: '700', color: '#111827' }}>Nuevo Integrante</h4>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
        <div style={{ gridColumn: '1 / -1' }}>
          <label style={{ fontSize: '12px', fontWeight: '600', color: '#374151', display: 'block', marginBottom: '4px' }}>Proyecto</label>
          <select value={form.proyectoId} onChange={e => setForm(p => ({ ...p, proyectoId: e.target.value }))} required
            style={{ width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box', background: '#fff' }}>
            <option value="">Seleccionar proyecto...</option>
            {proyectos.map(p => {
              const pid = p.id || p._id;
              return <option key={pid} value={pid}>{p.nombre}</option>;
            })}
          </select>
        </div>
        <div>
          <label style={{ fontSize: '12px', fontWeight: '600', color: '#374151', display: 'block', marginBottom: '4px' }}>Nombre</label>
          <input value={form.nombre} onChange={e => setForm(p => ({ ...p, nombre: e.target.value }))}
            placeholder="Nombre completo" required
            style={{ width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }} />
        </div>
        <div>
          <label style={{ fontSize: '12px', fontWeight: '600', color: '#374151', display: 'block', marginBottom: '4px' }}>Email</label>
          <input type="email" value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))}
            placeholder="correo@ejemplo.com" required
            style={{ width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }} />
        </div>
        <div style={{ gridColumn: '1 / -1' }}>
          <label style={{ fontSize: '12px', fontWeight: '600', color: '#374151', display: 'block', marginBottom: '4px' }}>Cargo</label>
          <select value={form.cargo} onChange={e => setForm(p => ({ ...p, cargo: e.target.value }))} required
            style={{ width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box', background: '#fff' }}>
            <option value="">Seleccionar cargo...</option>
            {CARGOS.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>
      </div>
      {error && <p style={{ color: '#ef4444', fontSize: '12px', margin: '10px 0 0' }}>{error}</p>}
      <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
        <button type="submit" disabled={guardando}
          style={{ padding: '8px 20px', background: '#111827', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '13px', fontWeight: '600', cursor: guardando ? 'not-allowed' : 'pointer', opacity: guardando ? 0.7 : 1 }}>
          {guardando ? 'Agregando...' : 'Agregar Integrante'}
        </button>
        <button type="button" onClick={onCancelar}
          style={{ padding: '8px 16px', background: 'transparent', color: '#6b7280', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '13px', cursor: 'pointer' }}>
          Cancelar
        </button>
      </div>
    </form>
  );
};

// ── Modal para editar un integrante existente ──
const ModalEditarIntegrante = ({ miembro, onGuardado, onCancelar }) => {
  const [form, setForm] = useState({
    nombre: miembro.nombre || '',
    email: miembro.email || '',
    cargo: miembro.cargo || ''
  });
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.nombre || !form.email || !form.cargo) { setError('Todos los campos son obligatorios'); return; }
    setGuardando(true);
    try {
      const miembroId = miembro._id || miembro.id;
      await equipoService.actualizarMiembroEnProyecto(miembroId, form, miembro.proyectoId);
      onGuardado();
    } catch (err) {
      setError(err.mensaje || err.error || 'Error al actualizar integrante');
    } finally {
      setGuardando(false);
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, backdropFilter: 'blur(2px)' }}>
      <div style={{ width: '100%', maxWidth: '440px', background: '#fff', border: '1px solid #e5e7eb', borderRadius: '14px', boxShadow: '0 20px 60px rgba(0,0,0,0.18)', overflow: 'hidden' }}>
        <div style={{ background: 'linear-gradient(135deg, #111827 0%, #2d4a6d 100%)', padding: '18px 22px' }}>
          <h4 style={{ margin: 0, fontSize: '15px', fontWeight: 700, color: '#fff' }}>Editar Integrante</h4>
          <p style={{ margin: '4px 0 0', fontSize: '12px', color: 'rgba(255,255,255,0.65)' }}>{miembro.proyectoNombre}</p>
        </div>
        <form onSubmit={handleSubmit} style={{ padding: '20px 22px' }}>
          <div style={{ display: 'grid', gap: '12px' }}>
            <div>
              <label style={{ fontSize: '12px', fontWeight: '600', color: '#374151', display: 'block', marginBottom: '4px' }}>Nombre</label>
              <input value={form.nombre} onChange={e => setForm(p => ({ ...p, nombre: e.target.value }))}
                placeholder="Nombre completo" required
                style={{ width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }} />
            </div>
            <div>
              <label style={{ fontSize: '12px', fontWeight: '600', color: '#374151', display: 'block', marginBottom: '4px' }}>Email</label>
              <input type="email" value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))}
                placeholder="correo@ejemplo.com" required
                style={{ width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }} />
            </div>
            <div>
              <label style={{ fontSize: '12px', fontWeight: '600', color: '#374151', display: 'block', marginBottom: '4px' }}>Cargo</label>
              <select value={form.cargo} onChange={e => setForm(p => ({ ...p, cargo: e.target.value }))} required
                style={{ width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box', background: '#fff' }}>
                <option value="">Seleccionar cargo...</option>
                {CARGOS.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
          </div>
          {error && <p style={{ color: '#ef4444', fontSize: '12px', margin: '10px 0 0' }}>{error}</p>}
          <div style={{ display: 'flex', gap: '8px', marginTop: '18px' }}>
            <button type="submit" disabled={guardando}
              style={{ padding: '8px 20px', background: '#111827', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '13px', fontWeight: '600', cursor: guardando ? 'not-allowed' : 'pointer', opacity: guardando ? 0.7 : 1 }}>
              {guardando ? 'Guardando...' : 'Guardar Cambios'}
            </button>
            <button type="button" onClick={onCancelar}
              style={{ padding: '8px 16px', background: 'transparent', color: '#6b7280', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '13px', cursor: 'pointer' }}>
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// ── Formulario para crear un gerente ──
const FormNuevoGerente = ({ proyectos, onCreado, onCancelar }) => {
  const [form, setForm] = useState({ nombre: '', email: '', password: '', tipoGerente: 'general', proyectosAsignados: [] });
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');

  const toggleProyecto = (id) => {
    setForm(prev => ({
      ...prev,
      proyectosAsignados: prev.proyectosAsignados.includes(id)
        ? prev.proyectosAsignados.filter(p => p !== id)
        : [...prev.proyectosAsignados, id]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.nombre || !form.email || !form.password) { setError('Todos los campos son obligatorios'); return; }
    if (form.tipoGerente === 'proyecto' && form.proyectosAsignados.length === 0) { setError('Selecciona al menos un proyecto'); return; }
    setGuardando(true);
    try {
      await authService.crearGerente(form);
      onCreado();
    } catch (err) {
      setError(err.mensaje || err.error || 'Error al crear gerente');
    } finally {
      setGuardando(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '20px', marginTop: '16px' }}>
      <h4 style={{ margin: '0 0 16px', fontSize: '14px', fontWeight: '700', color: '#111827' }}>Nuevo Gerente</h4>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
        <div>
          <label style={{ fontSize: '12px', fontWeight: '600', color: '#374151', display: 'block', marginBottom: '4px' }}>Nombre</label>
          <input value={form.nombre} onChange={e => setForm(p => ({ ...p, nombre: e.target.value }))}
            placeholder="Nombre completo" required
            style={{ width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }} />
        </div>
        <div>
          <label style={{ fontSize: '12px', fontWeight: '600', color: '#374151', display: 'block', marginBottom: '4px' }}>Email</label>
          <input type="email" value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))}
            placeholder="correo@ejemplo.com" required
            style={{ width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }} />
        </div>
        <div>
          <label style={{ fontSize: '12px', fontWeight: '600', color: '#374151', display: 'block', marginBottom: '4px' }}>Contraseña</label>
          <input type="password" value={form.password} onChange={e => setForm(p => ({ ...p, password: e.target.value }))}
            placeholder="Mínimo 6 caracteres" required minLength={6}
            style={{ width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box' }} />
        </div>
        <div>
          <label style={{ fontSize: '12px', fontWeight: '600', color: '#374151', display: 'block', marginBottom: '4px' }}>Tipo de Gerente</label>
          <select value={form.tipoGerente} onChange={e => setForm(p => ({ ...p, tipoGerente: e.target.value, proyectosAsignados: [] }))}
            style={{ width: '100%', padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '13px', boxSizing: 'border-box', background: '#fff' }}>
            <option value="general">Gerente General (todos los proyectos)</option>
            <option value="proyecto">Gerente de Proyecto (proyectos asignados)</option>
          </select>
        </div>
      </div>

      {form.tipoGerente === 'proyecto' && (
        <div style={{ marginTop: '12px' }}>
          <label style={{ fontSize: '12px', fontWeight: '600', color: '#374151', display: 'block', marginBottom: '8px' }}>Proyectos asignados</label>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {proyectos.map(p => {
              const pid = p.id || p._id;
              const seleccionado = form.proyectosAsignados.includes(pid?.toString());
              return (
                <button key={pid} type="button" onClick={() => toggleProyecto(pid?.toString())}
                  style={{
                    padding: '5px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: '600', cursor: 'pointer',
                    background: seleccionado ? '#111827' : '#f3f4f6',
                    color: seleccionado ? '#fff' : '#374151',
                    border: `1px solid ${seleccionado ? '#111827' : '#d1d5db'}`
                  }}>
                  {p.nombre}
                </button>
              );
            })}
          </div>
        </div>
      )}

      {error && <p style={{ color: '#ef4444', fontSize: '12px', margin: '10px 0 0' }}>{error}</p>}

      <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
        <button type="submit" disabled={guardando}
          style={{ padding: '8px 20px', background: '#111827', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '13px', fontWeight: '600', cursor: guardando ? 'not-allowed' : 'pointer', opacity: guardando ? 0.7 : 1 }}>
          {guardando ? 'Creando...' : 'Crear Gerente'}
        </button>
        <button type="button" onClick={onCancelar}
          style={{ padding: '8px 16px', background: 'transparent', color: '#6b7280', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '13px', cursor: 'pointer' }}>
          Cancelar
        </button>
      </div>
    </form>
  );
};

// ── Componente principal ──
const TabGlobalEquipo = ({ usuarioActual }) => {
  const [datos, setDatos] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');
  const [filtroProyecto, setFiltroProyecto] = useState('todos');
  const [filtroCargo, setFiltroCargo] = useState('todos');

  const [mostrarFormIntegrante, setMostrarFormIntegrante] = useState(false);
  const [eliminandoMiembro, setEliminandoMiembro] = useState(null);
  const [editando, setEditando] = useState(null);

  const [gerentes, setGerentes] = useState([]);
  const [mostrarFormGerente, setMostrarFormGerente] = useState(false);
  const [eliminandoGerente, setEliminandoGerente] = useState(null);

  const esPropietario = usuarioActual?.tipoUsuario === 'propietario';
  const esGerente = usuarioActual?.tipoUsuario === 'gerente';

  const cargarDatos = () => {
    setCargando(true);
    Promise.all([
      api.get('/dashboard/global'),
      esPropietario ? authService.listarGerentes() : Promise.resolve([])
    ])
      .then(([res, gerentesData]) => {
        setDatos(res.data);
        setGerentes(gerentesData);
      })
      .catch(() => setError('No se pudieron cargar los datos'))
      .finally(() => setCargando(false));
  };

  useEffect(() => { cargarDatos(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleEliminarMiembro = async (miembroId, proyectoId) => {
    if (!window.confirm('¿Eliminar este miembro del equipo?')) return;
    setEliminandoMiembro(miembroId);
    try {
      await equipoService.eliminarMiembroEnProyecto(miembroId, proyectoId);
      cargarDatos();
    } catch (e) {
      alert(e.mensaje || 'Error al eliminar miembro');
    } finally {
      setEliminandoMiembro(null);
    }
  };

  const handleEliminarGerente = async (id) => {
    setEliminandoGerente(id);
    try {
      await authService.eliminarGerente(id);
      setGerentes(prev => prev.filter(g => (g.id || g._id) !== id));
    } catch (e) {
      alert(e.mensaje || 'Error al eliminar gerente');
    } finally {
      setEliminandoGerente(null);
    }
  };

  if (cargando) return (
    <div className="tab-content equipo-page">
      <section className="progress-section-v2">
        <div className="critical-header-bar"><h2 className="equipo-page-title">Equipo</h2></div>
        <p style={{ color: '#6b7280', padding: '32px', textAlign: 'center' }}>Cargando equipo...</p>
      </section>
    </div>
  );

  if (error) return (
    <div className="tab-content equipo-page">
      <section className="progress-section-v2">
        <p style={{ color: '#ef4444', padding: '32px', textAlign: 'center' }}>{error}</p>
      </section>
    </div>
  );

  const proyectos = datos?.proyectos || [];

  const todosLosMiembros = [];
  proyectos.forEach(item => {
    const proyectoId = item.proyecto.id || item.proyecto._id;
    (item.miembros || []).forEach(m => {
      todosLosMiembros.push({ ...m, proyectoNombre: item.proyecto.nombre, proyectoId });
    });
  });

  const nombresProyectos = [...new Set(proyectos.map(i => i.proyecto.nombre))];
  const cargosUnicos = [...new Set(todosLosMiembros.map(m => m.cargo).filter(Boolean))];

  const miembrosFiltrados = todosLosMiembros.filter(m => {
    if (filtroProyecto !== 'todos' && m.proyectoNombre !== filtroProyecto) return false;
    if (filtroCargo !== 'todos' && m.cargo !== filtroCargo) return false;
    return true;
  });

  // Agrupar por proyecto (en el mismo orden que vienen de la API) para mostrar
  // una tabla por proyecto en vez de una grilla plana con todos mezclados.
  const gruposPorProyecto = proyectos
    .map(item => {
      const proyectoId = item.proyecto.id || item.proyecto._id;
      const miembros = miembrosFiltrados.filter(m => m.proyectoId === proyectoId);
      return { proyectoId, proyectoNombre: item.proyecto.nombre, miembros };
    })
    .filter(grupo => grupo.miembros.length > 0);

  const proyectosParaForm = proyectos.map(i => i.proyecto);

  return (
    <div className="tab-content equipo-page">

      {/* ── SECCIÓN MIEMBROS DE EQUIPO ── */}
      <section className="progress-section-v2">
        <div className="critical-header-bar">
          <h2 className="equipo-page-title">Equipo</h2>
          <span className="progress-header-date">
            {miembrosFiltrados.length} de {todosLosMiembros.length} miembro{todosLosMiembros.length !== 1 ? 's' : ''}
          </span>
          {(esPropietario || esGerente) && !mostrarFormIntegrante && (
            <button onClick={() => setMostrarFormIntegrante(true)}
              style={{ marginLeft: 'auto', padding: '5px 14px', background: '#111827', color: '#fff', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: '600', cursor: 'pointer' }}>
              + Agregar Integrante
            </button>
          )}
        </div>

        {mostrarFormIntegrante && (
          <FormNuevoIntegrante
            proyectos={proyectosParaForm}
            onCreado={() => { setMostrarFormIntegrante(false); cargarDatos(); }}
            onCancelar={() => setMostrarFormIntegrante(false)}
          />
        )}

        {todosLosMiembros.length > 0 && (
          <div style={{ display: 'flex', gap: '10px', marginTop: '14px', flexWrap: 'wrap' }}>
            <select value={filtroProyecto} onChange={e => setFiltroProyecto(e.target.value)}
              style={{ padding: '6px 10px', borderRadius: '6px', border: '1px solid #d1d5db', fontSize: '13px', color: '#374151', background: '#fff', cursor: 'pointer' }}>
              <option value="todos">Todos los proyectos</option>
              {nombresProyectos.map(n => <option key={n} value={n}>{n}</option>)}
            </select>
            <select value={filtroCargo} onChange={e => setFiltroCargo(e.target.value)}
              style={{ padding: '6px 10px', borderRadius: '6px', border: '1px solid #d1d5db', fontSize: '13px', color: '#374151', background: '#fff', cursor: 'pointer' }}>
              <option value="todos">Todos los cargos</option>
              {cargosUnicos.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
        )}

        {miembrosFiltrados.length === 0 ? (
          <p style={{ color: '#6b7280', padding: '32px', textAlign: 'center' }}>
            {todosLosMiembros.length === 0 ? 'No hay miembros de equipo registrados' : 'No hay miembros que coincidan con los filtros'}
          </p>
        ) : (
          gruposPorProyecto.map(grupo => (
            <div key={grupo.proyectoId} style={{ marginTop: '20px' }}>
              <div className="critical-title-row">
                <span className="critical-square" style={{ color: '#111827' }}>■</span>
                <span className="critical-title-text">{grupo.proyectoNombre}</span>
                <span className="critical-count-badge" style={{ background: '#f3f4f6', color: '#111827' }}>{grupo.miembros.length}</span>
              </div>
              <div className="table-wrapper">
                <table className="critical-table-email">
                  <thead>
                    <tr>
                      <th style={{ width: '60px', textAlign: 'center' }}></th>
                      <th>Nombre</th>
                      <th>Cargo</th>
                      <th>Correo</th>
                      <th style={{ width: '110px', textAlign: 'center' }}>Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    {grupo.miembros.map((m, idx) => {
                      const miembroId = m._id || m.id;
                      return (
                        <tr key={`${miembroId || m.email}-${idx}`} className={idx % 2 === 0 ? 'row-even' : 'row-odd'}>
                          <td style={{ textAlign: 'center' }}>
                            <div className="member-avatar-table" style={{ background: getCargoColor(m.cargo) }}>
                              {(m.nombre || '?').charAt(0).toUpperCase()}
                            </div>
                          </td>
                          <td><strong>{m.nombre}</strong></td>
                          <td>
                            {m.cargo && <span className="status-badge" style={{ background: '#f9fafb', color: '#374151' }}>{m.cargo}</span>}
                          </td>
                          <td style={{ fontSize: '13px', color: '#6b7280' }}>{m.email}</td>
                          <td style={{ textAlign: 'center' }}>
                            {(esPropietario || esGerente) && (
                              <div style={{ display: 'flex', gap: '6px', justifyContent: 'center' }}>
                                <button
                                  className="btn-action"
                                  onClick={() => setEditando({ ...m, proyectoId: grupo.proyectoId })}
                                  title="Editar miembro"
                                  style={{ background: '#eff6ff', color: '#2563eb' }}
                                >
                                  ✎
                                </button>
                                <button
                                  className="btn-action btn-delete"
                                  onClick={() => handleEliminarMiembro(miembroId, grupo.proyectoId)}
                                  disabled={eliminandoMiembro === miembroId}
                                  title="Eliminar miembro"
                                  style={{ opacity: eliminandoMiembro === miembroId ? 0.5 : 1 }}
                                >
                                  ✕
                                </button>
                              </div>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          ))
        )}
      </section>

      {/* ── SECCIÓN GERENTES (solo propietario) ── */}
      {esPropietario && (
        <section className="progress-section-v2" style={{ marginTop: '24px' }}>
          <div className="critical-header-bar">
            <span className="progress-badge" style={{ background: '#111827' }}>GERENTES</span>
            <span className="progress-header-date">{gerentes.length} gerente{gerentes.length !== 1 ? 's' : ''}</span>
          </div>

          {/* Lista de gerentes */}
          {gerentes.length > 0 && (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '12px', marginTop: '16px' }}>
              {gerentes.map(g => {
                const gid = g.id || g._id;
                const color = GERENTE_COLOR[g.tipoGerente] || '#6b7280';
                return (
                  <div key={gid}
                    style={{ background: '#fff', border: '1px solid #e5e7eb', borderLeft: `4px solid ${color}`, borderRadius: '10px', padding: '16px', boxShadow: '0 1px 4px rgba(0,0,0,0.05)' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <div style={{ width: '44px', height: '44px', borderRadius: '50%', flexShrink: 0, background: color, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '17px', fontWeight: '800' }}>
                        {(g.nombre || '?').charAt(0).toUpperCase()}
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <p style={{ margin: 0, fontSize: '14px', fontWeight: '700', color: '#111827', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{g.nombre}</p>
                        <p style={{ margin: '2px 0 0', fontSize: '11px', fontWeight: '600', color }}>
                          {g.tipoGerente === 'general' ? 'Gerente General' : 'Gerente de Proyecto'}
                        </p>
                        <p style={{ margin: '2px 0 0', fontSize: '11px', color: '#9ca3af', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{g.email}</p>
                      </div>
                      <button onClick={() => handleEliminarGerente(gid)} disabled={eliminandoGerente === gid}
                        title="Eliminar gerente"
                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ef4444', fontSize: '16px', padding: '4px', flexShrink: 0, opacity: eliminandoGerente === gid ? 0.4 : 1 }}>
                        ✕
                      </button>
                    </div>
                    {g.tipoGerente === 'proyecto' && g.proyectosAsignados?.length > 0 && (
                      <div style={{ marginTop: '10px', display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                        {proyectosParaForm.filter(p => g.proyectosAsignados.includes((p.id || p._id)?.toString())).map(p => (
                          <span key={p.id || p._id} style={{ fontSize: '11px', background: '#f3f4f6', color: '#374151', padding: '2px 8px', borderRadius: '10px', fontWeight: '600' }}>
                            {p.nombre}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}

          {/* Botón / formulario */}
          {mostrarFormGerente ? (
            <FormNuevoGerente
              proyectos={proyectosParaForm}
              onCreado={() => { setMostrarFormGerente(false); cargarDatos(); }}
              onCancelar={() => setMostrarFormGerente(false)}
            />
          ) : (
            <button onClick={() => setMostrarFormGerente(true)}
              style={{ marginTop: '16px', padding: '9px 20px', background: '#111827', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>
              + Agregar Gerente
            </button>
          )}
        </section>
      )}

      {editando && (
        <ModalEditarIntegrante
          miembro={editando}
          onGuardado={() => { setEditando(null); cargarDatos(); }}
          onCancelar={() => setEditando(null)}
        />
      )}
    </div>
  );
};

export default TabGlobalEquipo;
